/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export interface UnreadableStream<T> {
  read(): T;

  unread(value: T): void;

  position(): number;
}

export function unreadableStream<T>(iterator: Iterator<T>): UnreadableStream<Maybe<T>> {
  const buffer: T[] = [];
  let currentPosition = 0;

  const read = () => {
    currentPosition++;
    if (buffer.length === 0) {
      return iterator.next().value;
    } else {
      return <T>buffer.shift();
    }
  };

  const unread = (value: T) => {
    currentPosition--;
    buffer.unshift(value);
  };

  const position = () => currentPosition;

  return { read, unread, position };
}

export function isSpaceChar(char: string): boolean {
  switch (char) {
    case ' ':
    case '\t':
    case '\n':
    case '\r':
      return true;
    default:
      return false;
  }
}
